import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useTranslation } from "@/hooks/useTranslation";
import { CoinsIcon, ShoppingCartIcon } from "lucide-react";

interface CardApiCreditsOverviewProps {
  balance: number;
  isLoading: boolean;
  onBuyCredits: () => void;
}

export function CardApiCreditsOverview({
  balance,
  isLoading,
  onBuyCredits,
}: CardApiCreditsOverviewProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Card>
        <CardContent className="flex items-center gap-4 pt-6">
          <Skeleton className="h-10 w-10 rounded-lg" />
          <div className="space-y-2 flex-1">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-16" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="flex items-center gap-4 pt-6">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-majorelle/10">
          <CoinsIcon className="h-5 w-5 text-majorelle" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-muted-foreground">{t("team.apiCredits.overview.balance")}</p>
          <p className="text-2xl font-bold">
            {new Intl.NumberFormat("fr-FR").format(balance)}
          </p>
        </div>
        <div className="shrink-0">
          <Button size="sm" onClick={onBuyCredits}>
            <ShoppingCartIcon className="w-4 h-4 mr-1.5" />
            {t("team.apiCredits.overview.buyCredits")}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
